module.exports = __webpack_public_path__ + "static/media/redux.afb369f7.png";